import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';

export async function postApiV2CustomersCustomerIdUnhold() {
  return send({
    path: '/api/v2/customers/self/unhold',
    method: 'POST',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
